import type { GetServerSideProps, NextPage } from 'next';
import dynamic from 'next/dynamic';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { LineSB, MetaData } from '@mwl/core-lib';
import { checkUserAuthOnServer, getLineByIdSB, useWebsocketLineFull } from '@mwl/core-lib';
import { base, defaultLocale } from '@/constants';
import { wrapperStore } from '@/store/store';
import { getNamespaces } from '@/utils';
const Layout = dynamic(() => import('@/Layouts/Layout/Layout').then(mod => mod.Layout));
const SportLayout = dynamic(() => import('@/Layouts/SportLayout/SportLayout').then(mod => mod.SportLayout));
const LinePage = dynamic(() => import('@/modules/sport/pages/LinePage/LinePage').then(mod => mod.LinePage));
interface SportDetailsProps {
  line: LineSB;
  meta: MetaData;
}
const SportDetails: NextPage<SportDetailsProps> = ({
  line: initialLine,
  meta
}) => {
  const line = useWebsocketLineFull(initialLine, base.NAME_PROJECT);
  return <Layout sticky {...meta} data-sentry-element="Layout" data-sentry-component="SportDetails" data-sentry-source-file="[lineId].tsx">
      <SportLayout hideToolbar data-sentry-element="SportLayout" data-sentry-source-file="[lineId].tsx">
        <LinePage line={line} data-sentry-element="LinePage" data-sentry-source-file="[lineId].tsx" />
      </SportLayout>
    </Layout>;
};
export const getServerSideProps: GetServerSideProps<Partial<SportDetailsProps>> = wrapperStore.getServerSideProps(({
  dispatch
}) => async ({
  locale = defaultLocale,
  req,
  res,
  params
}) => {
  const {
    localServerAxiosInstance
  } = await checkUserAuthOnServer({
    dispatch,
    locale,
    res,
    req
  });
  const lineId = (params?.lineId as string);
  const {
    status,
    data
  } = await getLineByIdSB(lineId, undefined, localServerAxiosInstance);
  if (status !== 200 || !data) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      ...(await serverSideTranslations(locale, getNamespaces('sport'))),
      line: data,
      meta: {
        title: 'title.sport_line',
        description: 'description.sport_line',
        metaVariables: {
          sport_title: data.sport.title,
          category_title: data.category.title,
          championship_title: data.championship.title,
          line_title: data.competitors.map(competitor => competitor.title).join(', ')
        }
      }
    }
  };
});
export default SportDetails;